import React, { useState, useEffect } from 'react';
import { Paper, TextField, Box, Tab, Tabs, Typography, Grid, Divider, FormControl, Button, Snackbar, Alert, Stack, Switch } from '@mui/material'
import { ReactComponent as ProfileLogo } from '../assets/images/profile_pic.svg';
import ChangePassword from '../components/profile/ChangePassword';
import ChangeEmail from '../components/profile/ChangeEmail';
import { useSelector, useDispatch } from 'react-redux';
import { toggleAI } from '../features/settings/settingsSlice';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

const Profile = ({ signOut, user }) => {
    const [selectedTab, setSelectedTab] = useState(0);
    const [snackbarInfo, setSnackbarInfo] = useState({
        open: false,
        message: "",
        severity: "",
    });
    const [userInfo, setUserInfo] = useState({
        name: '',
        email: '',
        phone_number: ''
    });
    const { enableAI } = useSelector(store => store.settings)
    const dispatch = useDispatch();


    useEffect(() => {
        setSelectedTab(0);
    }, [])



    const handleClose = () => {
        setSnackbarInfo({ ...snackbarInfo, open: false });
    }

    const handleTabSelection = (event, selection) => {
        setSelectedTab(selection);
    };

    return (
        <>
            <Paper sx={{ backgroundColor: 'rgb(255, 255, 255)', padding: '20px', borderRadius: '10px', width: '100%' }}>
                <Box sx={{ flexGrow: 1, bgcolor: 'background.paper', display: 'flex' }}>
                    <Box sx={{ borderRight: 1, borderColor: 'divider' }}>
                        <Tabs
                            orientation="vertical"
                            value={selectedTab}
                            onChange={(e, value) => handleTabSelection(e, value)}
                            aria-label="basic tabs example"
                        >
                            <Tab label="Profile" />
                            <Tab label="Update Password" />
                            <Tab label="Update Email" />
                            {/* <Tab label="Settings" /> */}
                        </Tabs>
                    </Box>
                    <TabPanel value={selectedTab} index={0}>
                        <Grid container>
                            <Grid size="auto" sx={{
                                padding: '10px'
                            }}>
                                <ProfileLogo style={{
                                    height: '300px',
                                    width: '300px'
                                }} />
                            </Grid>
                            <Divider orientation="vertical" variant="middle" flexItem />
                            <Grid size="auto" >
                                <FormControl fullWidth size="small">
                                    <TextField
                                        required
                                        id="outlined-required"
                                        label="Name"
                                        defaultValue={userInfo?.name}
                                        sx={{ margin: 1 }}
                                    />
                                </FormControl>
                                <FormControl fullWidth size="small">
                                    <TextField
                                        required
                                        id="outlined-required"
                                        label="Email"
                                        defaultValue={userInfo?.email}
                                        sx={{ margin: 1 }}
                                    />
                                </FormControl>
                                <FormControl fullWidth size="small">
                                    <TextField
                                        required
                                        id="outlined-required"
                                        label="Phone"
                                        defaultValue={userInfo?.phone_number}
                                        sx={{ margin: 1 }}
                                    />
                                </FormControl>
                                <Button
                                    size='small'
                                    sx={{ flex: 1, m: 1 }}
                                >Update</Button>
                            </Grid>
                        </Grid>
                    </TabPanel>
                    <TabPanel value={selectedTab} index={1}>
                        <ChangePassword setSnackbarInfo={setSnackbarInfo} />
                    </TabPanel>
                    <TabPanel value={selectedTab} index={2}>
                        <ChangeEmail user={user} signOut={signOut} />
                    </TabPanel>
                    {/* <TabPanel value={selectedTab} index={3}>
                        <Box>
                            <Stack direction="row" spacing={1} alignItems="center">
                                <Typography>Enable RWE AI:</Typography>
                                <Switch value={enableAI} onChange={() => dispatch(toggleAI())} />
                            </Stack>
                        </Box>
                    </TabPanel> */}
                </Box>
                <Snackbar open={snackbarInfo.open} autoHideDuration={6000} onClose={() => handleClose()} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
                    <Alert onClose={() => handleClose()} severity={snackbarInfo.severity || 'info'} sx={{ width: '100%' }}>
                        {snackbarInfo.message}
                    </Alert>
                </Snackbar>
            </Paper >
        </>
    )
}

export default Profile;